import { useLocation, useNavigate } from "react-router-dom";

import { LineLinkCard } from "../components/LineLinkCard";
import { UI_TEXT_TONE } from "../lib/uiTone";

type LineLinkRouteState = {
  returnTo?: string;
  returnState?: unknown;
};

export default function LineLinkPopup() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeState = (typeof location.state === "object" && location.state ? location.state : {}) as LineLinkRouteState;
  const returnTo = String(routeState.returnTo || "/home");

  const closePopup = () => {
    navigate(returnTo, { replace: true, state: routeState.returnState });
  };

  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(244,227,215,0.9),_rgba(253,248,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-xl items-center justify-center">
        <div className="relative w-full max-w-full rounded-[2.4rem] border border-white/80 bg-white/90 p-4 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <button
            type="button"
            onClick={closePopup}
            aria-label="閉じる"
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#EADBC8] bg-[#FFF8F4] text-[#7C5A4E] transition hover:bg-white"
          >
            ×
          </button>

          <div className="mb-4 pr-12">
            <h1 className={`text-2xl font-black tracking-tight ${UI_TEXT_TONE.title}`}>LINE連携</h1>
          </div>

          <LineLinkCard />
        </div>
      </div>
    </main>
  );
}
